<!--
    描述：评价记录页面
    Created by asq

	step1:
    编辑于      2021-3-18
    编辑人      王帅
    编辑内容:   优化调整 组件传参方式，改props 为 session传参，去除冗余无效代码
-->
<template>
    <div class="filter-layout">
        <template v-if="!routeQuery">
            <div class="filter-box pdt10">
                <el-form :model="searchForm" v-show="filterShow" label-width="130px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="评价项目：">
                                <el-input
                                    :placeholder="'请输入'"
                                    clearable
                                    v-model="searchForm.objName"
                                    size="small"
                                >
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="评价人：">
                                <el-input
                                    :placeholder="'请输入'"
                                    clearable
                                    v-model="searchForm.judger"
                                    size="small"
                                >
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="被评价人：">
                                <el-input
                                    :placeholder="'请输入'"
                                    clearable
                                    v-model="searchForm.beJudger"
                                    size="small"
                                >
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="业务来源：">
                                <el-select
                                    v-model="searchForm.source"
                                    placeholder="请选择"
                                    size="small"
                                >
                                    <el-option
                                        v-for="(item, index) in ywly"
                                        :key="'业务' + index"
                                        :label="item.sname"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="评价结果：">
                                <el-select
                                    v-model="searchForm.markResult"
                                    placeholder="请选择"
                                    size="small"
                                >
                                    <el-option label="差评" value="0"></el-option>
                                    <el-option label="良好" value="1"></el-option>
                                    <el-option label="优秀" value="2"></el-option>
                                    <el-option label="完美" value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="评价时间：">
                                <el-date-picker
                                    v-model="searchForm.evaTime"
                                    type="daterange"
                                    unlink-panels
                                    :default-time="['00:00:00', '23:59:59']"
                                    size="small"
                                    start-placeholder="请选择"
                                    end-placeholder="请选择"
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>

                        <el-col :span="5" class="mt4 ml10">
                            <el-button
                                type="primary"
                                class="btn-blue"
                                size="small"
                                @click="searchResult"
                                >查询</el-button
                            >
                            <el-button type="warning" size="small" @click="resetSerach"
                                >重置</el-button
                            >
                        </el-col>
                    </el-row>
                </el-form>
                <!-- 筛选折叠按钮 -->
                <div class="control-btn" @click="filterShow = !filterShow">
                    <span v-if="filterShow">
                        点击收起
                        <svg-icon icon-class="pack-up" class="c-icon ml5"></svg-icon>
                    </span>
                    <span v-else
                        >筛选
                        <svg-icon icon-class="pack-down" class="c-icon ml5"></svg-icon>
                    </span>
                </div>
            </div>
            <div class="filter-content primary-layout">
                <div class="primary-header">
                    <div class="title">
                        合计评价记录： <span class="blue">{{ total }}</span> 条
                    </div>
                    <div class="mt10 mb10 fr">
                        <el-button
                            size="small"
                            class="btn-blue"
                            icon="el-icon-refresh"
                            type="primary"
                            @click="resetSerach"
                        ></el-button>
                    </div>
                </div>
                <div class="primary-content w-table-layout w-table-page">
                    <div class="w-table-content" v-show="tableShow">
                        <el-table
                            ref="xTable"
                            :data="filterData"
                            height="100%"
                            highlight-current-row
                            border
                        >
                            <el-table-column
                                type="index"
                                label="序号"
                                align="center"
                                width="80"
                            ></el-table-column>
                            <el-table-column
                                prop="serialNo"
                                label="流水号"
                                align="center"
                                width="120"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="createDate"
                                label="评价时间"
                                align="center"
                                width="140"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="judger"
                                label="评价人"
                                align="center"
                                width="100"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="judgeRoleName"
                                label="评价人角色"
                                align="center"
                                width="100"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="judgeType"
                                label="评价人主体类型"
                                align="center"
                                width="120"
                                show-overflow-tooltip
                            >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.judgeType == 0">个人</span>
                                    <span v-else-if="scope.row.judgeType == 1">企业</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="beJudger"
                                label="被评价人"
                                align="center"
                                min-width="100"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="beJudgeRoleName"
                                label="被评价人角色"
                                align="center"
                                min-width="140"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="beJudgeType"
                                label="被评价人主体类型"
                                align="center"
                                width="140"
                                show-overflow-tooltip
                            >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.beJudgeType == 0">个人</span>
                                    <span v-else-if="scope.row.beJudgeType == 1"
                                        >企业</span
                                    >
                                </template></el-table-column
                            >
                            <el-table-column
                                prop="markObjName"
                                label="评价对象"
                                align="center"
                                min-width="120"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="objName"
                                label="评价项目"
                                align="center"
                                width="160"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="sourceName"
                                label="业务来源"
                                align="center"
                                width="100"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column
                                prop="markResult"
                                label="评价结果"
                                align="center"
                                width="100"
                                show-overflow-tooltip
                            >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.markResult == 0">差评</span>
                                    <span v-else-if="scope.row.markResult == 1"
                                        >良好</span
                                    >
                                    <span v-else-if="scope.row.markResult == 2"
                                        >优秀</span
                                    >
                                    <span v-else-if="scope.row.markResult == 3"
                                        >完美</span
                                    >
                                </template></el-table-column
                            >
                            <el-table-column
                                prop="score"
                                label="分值"
                                align="center"
                                width="80"
                                show-overflow-tooltip
                            ></el-table-column>
                            <el-table-column align="center" width="100">
                                <template slot="header">操作</template>
                                <template slot-scope="scope">
                                    <el-button
                                        type="primary"
                                        size="small"
                                        round
                                        plain
                                        class="table-btn"
                                        @click="getDetail(scope.row)"
                                    >
                                        <svg-icon icon-class="form-details"></svg-icon>
                                        详情
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="w-table-footer">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="pageList"
                            :page-size="pageSize"
                            :total="total"
                            layout="total, sizes, prev, pager, next, jumper"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="routeQuery">
            <RecordsDetail></RecordsDetail>
        </template>
    </div>
</template>

<script>
import { getRecordsData } from "api/evaluateManage/EvaluateRecords";
import { mapState } from "vuex";
import RecordsDetail from "./RecordsDetail";
import { dateFormat } from "utils/tools";
export default {
    name: "Evaluate-records",
    components: {
        RecordsDetail,
    },
    data() {
        return {
            filterShow: true,
            filterData: [],
            searchForm: {
                objName: "",
                judger: "",
                beJudger: "",
                source: "",
                markResult: "",
                evaTime: "",
                startTime: "",
                endTime: "",
            },
            loading: false,
            //筛选框
            currentPage: 1, // 当前页码
            pageList: [10, 20, 50, 100], // 显示条数数组
            pageSize: 10, // 当前显示条数
            total: 0, // 当前总条数
            searchToggle: true,
            tableShow: true,
        };
    },
    created() {
        // 如果是 返回的
        if (this.isBack) {
            if (this.$getSessionItem("searchForm")) {
                this.searchForm = JSON.parse(this.$getSessionItem("searchForm"));

                // 移除 避免污染
                this.$removeSessionItem("searchForm");
            }

            if (this.$getSessionItem("currentPage")) {
                this.currentPage = JSON.parse(this.$getSessionItem("currentPage"));

                // 移除 避免污染
                this.$removeSessionItem("currentPage");
            }

            if (this.$getSessionItem("pageSize")) {
                this.pageSize = JSON.parse(this.$getSessionItem("pageSize"));

                // 移除 避免污染
                this.$removeSessionItem("pageSize");
            }
            if (this.$getSessionItem("detailData")) {
                // 移除 避免污染
                this.$removeSessionItem("detailData");
            }
        }
        this.getData();
    },
    methods: {
        //获得列表数据
        getData() {
            if (this.searchForm.evaTime != "" && this.searchForm.evaTime != null) {
                this.searchForm.startTime = dateFormat("", this.searchForm.evaTime[0]);
                this.searchForm.endTime = dateFormat("", this.searchForm.evaTime[1]);
            } else {
                this.searchForm.startTime = "";
                this.searchForm.endTime = "";
            }
            let params = Object.assign({}, this.searchForm);
            this.loading = true;
            // 分页参数
            params.current = this.currentPage;
            params.size = this.pageSize;
            getRecordsData(params)
                .then((res) => {
                    this.loading = false;
                    this.filterData = res.data.records;
                    this.currentPage = parseInt(res.data.current);
                    this.total = parseInt(res.data.total);
                    this.pageSize = parseInt(res.data.size);
                    // 设置回显
                    this.setChecked();
                })
                .catch((err) => {
                    this.loading = false;
                });
        },

        //查看明细
        getDetail(params) {
            this.detailData = params;

            // 存值
            this.$setSessionItem("searchForm", JSON.stringify(this.searchForm));
            this.$setSessionItem("currentPage", JSON.stringify(this.currentPage));
            this.$setSessionItem("pageSize", JSON.stringify(this.pageSize));

            // 数据
            this.$setSessionItem("detailData", JSON.stringify(params));

            // 储存当前菜单
            let obj = {
                // meta: this.$route.meta,
                path: this.$route.path,
                name: this.$route.name,
            };
			this.$setSessionItem(
				'activeMenu',
				JSON.stringify(obj)
			)

            this.$router.push({
                path: "/evaluate-records",
                query: {
                    type: "detail",
                    id: params.id,
                },
            });
        },

        // 切换显示条数
        handleSizeChange(val) {
            this.pageSize = val;
            this.getData();
        },

        //切换当前页码
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getData();
        },

        // 是否展开搜索区域
        changeState() {
            this.searchToggle = !this.searchToggle;
        },

        // 搜索
        searchResult() {
            this.currentPage = 1;
            this.pageSize = 10;
            this.getData();
        },

        //重置筛选框
        resetSerach() {
            this.currentPage = 1;
            this.pageSize = 10;
            this.searchForm = {};
            this.getData();
        },
    },

    computed: {
        ...mapState("app", { isBack: (state) => state.isBack }),
        routeQuery() {
            return this.$route.query.type;
        },
        ...mapState("dict", {
            ywly: (state) => state.projectDict.ywly, // 业务类型数组,
        }),
    },

    watch: {
        // 监听 筛选元素的 切换展示 重新调整表格高度
        searchToggle() {
            this.tableShow = false;
            setTimeout(() => {
                this.tableShow = true;
            }, 50);
            setTimeout(() => {
                this.$refs.xTable.doLayout();
            }, 1000);
        },
    },
};
</script>

<style lang="less" scoped>
.filter-layout {
    // padding: 0 8px;
    .search {
        border-bottom: 1px solid #2672cc;
        padding: 5px 0;
    }
    .mt4 {
        margin-top: 4px;
    }
    .cmain {
        height: 100%;
        overflow-y: auto;
    }
}
</style>
